import styled from 'styled-components';
import { Spacing16, Spacing24 } from 'autogen/design-tokens/tokens';
import type { VariantPickerModel } from 'autogen/swagger/all';
import PriceModule from 'components/generic/PriceModule';
import HorizontalList from './HorizontalList';
import { containerMargin } from './shared/styles';

// #region Styles
const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${Spacing16};
    padding-top: ${Spacing24};
    padding-bottom: ${Spacing24};
`;

const StyledPriceModule = styled(PriceModule)`
    padding-bottom: ${Spacing16};

    ${containerMargin}
`;

// #endregion Styles

type HorizontalSelectionProps = Pick<VariantPickerModel, 'sections' | 'price'>;

export default function HorizontalSelection({ price, sections }: HorizontalSelectionProps) {
    return (
        <Wrapper>
            {sections.map(({ variants }, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <HorizontalList variants={variants} key={index} />
            ))}

            <StyledPriceModule {...{ ...price, priceLabel: undefined }} />
        </Wrapper>
    );
}
